/* Ensures the Kalles customer grid switch controls apply their selected desktop width. */
(function () {
  var widths = { '6': '50%', '4': '33.333333%', '3': '25%', '15': '20%', '2': '16.666667%', listt4: '100%' };
  function selectedColumn(card) {
    var match = card.className.match(/(?:^|\s)col-lg-(listt4|15|[2346])(?:\s|$)/);
    return match ? match[1] : null;
  }
  function applyGrid(column) {
    if (window.innerWidth < 1025) return;
    document.querySelectorAll('.container_cat .nt_products_holder > .nt_pr').forEach(function (card) {
      var value = column || selectedColumn(card);
      if (!value || !widths[value]) return;
      card.style.setProperty('flex-basis', widths[value], 'important');
      card.style.setProperty('max-width', widths[value], 'important');
    });
  }
  document.addEventListener('DOMContentLoaded', function () { applyGrid(); });
  window.addEventListener('load', function () { applyGrid(); });
  document.addEventListener('click', function (event) {
    var control = event.target.closest('.cat_view_page[data-dev="dk"]');
    if (!control) return;
    window.setTimeout(function () { applyGrid(control.getAttribute('data-col')); }, 0);
  });
}());